export const GET_USER = 'GET_USER'
export const SEARCH_BUCKETS_TEXT = 'SEARCH_BUCKETS_TEXT'
export const SEARCH_USERS = 'SEARCH_USERS'
export const SEARCH_USERS_V2 = 'SEARCH_USERS_V2'
export const GET_BUCKET = 'GET_BUCKET'
export const GET_BUCKET_INVOICES = 'GET_BUCKET_INVOICES'
export const GET_PROCESSES = 'GET_PROCESSES'
export const GET_USER_BUCKETS = 'GET_USER_BUCKETS'
export const GET_USER_STATS = 'GET_USER_STATS'
export const GET_NODES = 'GET_NODES'
export const GET_PLANS = 'GET_PLANS'
export const UPGRADE_PLAN = 'UPGRADE_PLAN'
export const SWITCH_NODE = 'SWITCH_NODE'
export const SWITCH_ENTERPRISE = 'SWITCH_ENTERPRISE'
export const UPDATE_BUCKET = 'UPDATE_BUCKET'
export const START_TRIAL = 'START_TRIAL'
export const UPDATE_USER = 'UPDATE_USER'
export const DELETE_OTP = 'DELETE_OTP'
export const GET_ZENDESK_ID = 'GET_ZENDESK_ID'
export const SEARCH_BUCKETS = 'SEARCH_BUCKETS'
export const COUNT_BUCKETS = 'COUNT_BUCKETS'
export const EXPORT_CSV_BUCKETS = 'EXPORT_CSV_BUCKETS'
export const GET_LAST_PROCESSES_COUNT = 'GET_LAST_PROCESSES_COUNT'
export const CREATE_USER = 'CREATE_USER'
export const CREATE_BUCKET = 'CREATE_BUCKET'
export const BUCKET_COUNT = 'BUCKET_COUNT'
export const CREATE_PO = 'CREATE_PO'
export const DOWNLOAD_PO = 'DOWNLOAD_PO'
export const GET_POS = 'GET_POS'
export const GET_PO = 'GET_PO'
export const EDIT_PO = 'EDIT_PO'
export const EXPORT_CSV_USERS = 'EXPORT_CSV_USERS'
export const DELETE_PO = 'DELETE_PO'
export const COUNT_USERS = 'COUNT_USERS'
export const CHECK_PO_STRIPE_PAYABLE = 'CHECK_PO_STRIPE_PAYABLE'
export const GET_BEST_DOWNLOADERS = 'GET_BEST_DOWNLOADERS'
export const GET_DOWNLOADER_STATS = 'GET_DOWNLOADER_STATS'
export const GET_DOWNLOADER_LAST = 'GET_DOWNLOADER_LAST'
export const UPDATE_BUCKET_WARNING = 'UPDATE_BUCKET_WARNING'
export const GET_DOCUSIGN_PARAMS = 'GET_DOCUSIGN_PARAMS'
export const SEND_DOCUSIGN_PO = 'SEND_DOCUSIGN_PO'
export const GET_LATEST_PAYING_BUCKETS = 'GET_LATEST_PAYING_BUCKETS'
export const SET_SNACKBAR = 'SET_SNACKBAR'

export const actions = {
  [GET_USER] ({ commit }) {
    return window.io.user.retrieve().then(res => {
      commit('SET_USER', { user: res.data })
      return res.data
    })
  },
  [GET_BUCKET] ({ commit, dispatch }, { id, getProcesses }) {
    return window.io.backoffice.bucket.fetch(id).then(res => {
      const bucket = res.data
      if (!getProcesses) {
        return bucket
      }
      dispatch(GET_PROCESSES, { id })
        .then(processesHistory => {
          if (processesHistory !== undefined) bucket.processesHistory = processesHistory.histogram
          commit('SET_BUCKETS', { buckets: [bucket] })
          return bucket
        })
        .catch(_ => {
          commit('SET_BUCKETS', { buckets: [bucket] })
          return bucket
        })
    })
  },
  [GET_BUCKET_INVOICES] (_, { id }) {
    return window.io.backoffice.bucket.getInvoices(id).then(res => {
      return res.data
    })
  },
  [SEARCH_BUCKETS_TEXT] ({ commit }, { searchText }) {
    return window.io.backoffice.bucket
      .textSearch({
        query: {
          $or: [
            {
              _id: searchText
            },
            {
              public_id: searchText
            },
            {
              secret_id: searchText
            },
            {
              name: searchText
            }
          ]
        }
      })
      .then(res => {
        commit('SET_BUCKETS', { buckets: res.data })
        return res.data
      })
  },
  [SEARCH_USERS] ({ commit }, { searchText }) {
    return window.io.backoffice.user
      .search({
        query: {
          $or: [
            {
              _id: searchText
            },
            {
              email: searchText
            },
            {
              username: searchText
            }
          ]
        }
      })
      .then(res => {
        commit('SET_USERS', { users: res.data })
        return res.data
      })
  },
  [SEARCH_USERS_V2] ({ commit }, query) {
    return window.io.backoffice.user.searchV2(query).then(res => {
      return res.data
    })
  },
  [GET_USER_STATS] ({ commit }) {
    return window.io.backoffice.user.stats().then(res => {
      return res.data
    })
  },
  [EXPORT_CSV_USERS] ({ commit }, query) {
    return window.io.backoffice.user.exportCsv(query).then(res => {
      return res.data
    })
  },
  [GET_PROCESSES] ({ commit }, { id }) {
    return window.io.backoffice.bucket.getProcesses(id).then(res => {
      return res.data
    })
  },
  [GET_LAST_PROCESSES_COUNT] ({ commit }, { id }) {
    return window.io.backoffice.bucket.getLastProcessesCount(id).then(res => {
      return res.data
    })
  },
  [GET_USER_BUCKETS] ({ commit }, { email }) {
    return window.io.backoffice.user.getBuckets(email).then(res => {
      commit('SET_USERS', { users: [res.data.user] })
      return res.data
    })
  },
  [GET_NODES] ({ commit }) {
    return window.io.backoffice.node.fetch().then(res => {
      commit('SET_NODES', { nodes: res.data })
      return res.data
    })
  },
  [GET_PLANS] ({ commit }) {
    return window.io.misc.retrievePlans().then(res => {
      commit('SET_PLANS', { plans: res.data })
      return res.data
    })
  },
  [UPGRADE_PLAN] ({ commit }, { id, plan }) {
    return window.io.backoffice.bucket.upgrade(id, { plan }).then(res => {
      return res.data
    })
  },
  [SWITCH_NODE] ({ commit }, { id, node }) {
    return window.io.backoffice.bucket.balance(id, { node }).then(res => {
      return res.data
    })
  },
  [SWITCH_ENTERPRISE] (_, { id }) {
    return window.io.backoffice.bucket.switchToEnterprise(id)
  },
  [UPDATE_BUCKET] ({ commit }, { id, type, features, limitations, company, note, esCluster }) {
    return window.io.backoffice.bucket
      .update(id, {
        bucket: {
          company,
          note,
          type,
          features,
          limitations,
          es_cluster: esCluster
        }
      })
      .then(res => {
        return res.data
      })
  },
  [START_TRIAL] ({ commit }, data) {
    return window.io.startTrial(data.bucket).then(res => {
      return res.data
    })
  },
  [UPDATE_USER] ({ commit }, { id, user }) {
    return window.io.backoffice.user.updateUser(id, { user })
  },
  [DELETE_OTP] ({ commit }, { id }) {
    return window.io.backoffice.user.deleteOTP(id).then(res => {
      return res.data
    })
  },
  [GET_ZENDESK_ID] ({ commit }, { email }) {
    return window.io.backoffice.user.getZendeskId(email).then(res => {
      return res.data
    })
  },
  [SEARCH_BUCKETS] ({ commit }, query) {
    return window.io.backoffice.bucket.search(query).then(res => {
      return res.data
    })
  },
  [COUNT_BUCKETS] ({ commit }, query) {
    return window.io.backoffice.bucket.count(query).then(res => {
      return res.data
    })
  },
  [COUNT_USERS] ({ commit }, query) {
    return window.io.backoffice.user.count().then(res => {
      return res.data
    })
  },
  [EXPORT_CSV_BUCKETS] ({ commit }, query) {
    return window.io.backoffice.bucket.exportCsv(query).then(res => {
      return res.data
    })
  },
  [CREATE_USER] ({ commit }, { user }) {
    return window.io.backoffice.user.createUser(user).then(res => {
      return res.data
    })
  },
  [GET_LATEST_PAYING_BUCKETS] ({commit}, query) {
    return window.io.backoffice.bucket.latestPaying(query).then(res => {
      return res.data
    })
  },
  [CREATE_BUCKET] ({ commit }, data) {
    return window.io.backoffice.bucket.createBucket(data).then(res => {
      return res.data
    })
  },
  [BUCKET_COUNT] ({ commit }, { type }) {
    return window.io.backoffice.bucket
      .count({
        query: {
          type
        }
      })
      .then(res => {
        if (type === 'enterprise') {
          commit('SET_ENTERPRISE_BUCKET_COUNT', { enterpriseBucketCount: res.data.count })
          return res.data
        }
        commit('SET_BUCKET_COUNT', { bucketCount: res.data.count })
        return res.data
      })
  },
  [SET_SNACKBAR] ({ commit }, data) {
    commit('SET_SNACKBAR', data)
  },
  [CREATE_PO] (_, po) {
    return window.io.backoffice.purchaseorder.createPO({ po })
  },
  [DOWNLOAD_PO] (_, id) {
    return window.io.backoffice.purchaseorder.getPDF(id.toString()).then(res => {
      const doc = atob(res.data.doc)
      const ab = new ArrayBuffer(doc.length)
      const ia = new Uint8Array(ab)

      for (var i = 0; i < doc.length; i++) {
        ia[i] = doc.charCodeAt(i)
      }
      return new Blob([ab], { type: 'application/pdf' })
    })
  },
  [GET_POS] ({ commit }) {
    return window.io.backoffice.purchaseorder.listPO().then(res => {
      commit('SET_POS', res.data.list)
    })
  },
  [CHECK_PO_STRIPE_PAYABLE] (_, po) {
    return window.io.backoffice.purchaseorder.checkStripePayable({ po })
  },
  [GET_BEST_DOWNLOADERS] ({ commit }, { nbDays }) {
    return window.io.backoffice.pm2downloads.getBestDownloaders((1000).toString()).then(res => {
      commit('SET_BEST_DOWNLOADERS', res.data.aggregations.agg_terms_certHttps.buckets)
    })
  },
  [GET_DOWNLOADER_STATS] (_, { cert, aggregation }) {
    return window.io.backoffice.pm2downloads.getStats(cert, aggregation)
  },
  [GET_DOWNLOADER_LAST] (_, { cert }) {
    return window.io.backoffice.pm2downloads.getLast(cert)
  },
  [GET_PO] (_, { id }) {
    return window.io.backoffice.purchaseorder.getPO(id.toString())
  },
  [EDIT_PO] (_, po) {
    return window.io.backoffice.purchaseorder.updatePO(po.id.toString(), { po })
  },
  [DELETE_PO] (_, id) {
    return window.io.backoffice.purchaseorder.deletePO(id.toString())
  },
  [UPDATE_BUCKET_WARNING] ({ state }, { id, warning }) {
    return window.io.backoffice.bucket.updateWarning(id, { warning })
  },
  [GET_DOCUSIGN_PARAMS] ({ commit }) {
    return window.io.backoffice.docusign
      .checkAccess()
      .then(res => {
        commit('SET_DOCUSIGN_PARAMS', res.data.userInfo)
      })
      .catch(_ => {
        commit('SET_DOCUSIGN_PARAMS', null)
      })
  },
  [SEND_DOCUSIGN_PO] (_, { poID, draft, blurb }) {
    return window.io.backoffice.docusign.postEnvelope(poID.toString(), { draft, blurb })
  }
}
